import { buildApiUrl, toMockErrorResponse, toMockResponse } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'

const proxyRequest = async (request, fallbackMessage) => {
    try {
        const response = await request()
        if (!response?.data || typeof response.data !== 'object') {
            const rawResponse = String(response?.data || '')
            console.error(fallbackMessage, rawResponse)
            return [500, {
                error: 'Proxy Error',
                errorInfo: rawResponse || fallbackMessage,
                result: 'error',
            }]
        }
        return toMockResponse(response)
    } catch (error) {
        const response = toMockErrorResponse(error, fallbackMessage)
        console.error(fallbackMessage, response[1])
        return response
    }
}

Mock.onGet('/api/reference/clients/page').reply((config) => proxyRequest(
    () => axios.get(buildApiUrl('reference/getKlientDirectoryPage/'), { params: config?.params || {} }),
    'Ошибка загрузки страницы клиентов'
))

Mock.onGet('/api/reference/clients/search').reply((config) => proxyRequest(
    () => axios.get(buildApiUrl('reference/searchKlients/'), { params: config?.params || {} }),
    'Ошибка поиска клиентов'
))

Mock.onPost('/api/reference/getKlientInfo').reply((config) => {
    const { idKlient } = JSON.parse(config.data || '{}')
    return proxyRequest(
        () => axios.post(buildApiUrl('reference/getKlientInfo/'), {
            dataKlientDirectory: { id: idKlient, phone: 0 },
        }),
        'Ошибка загрузки карточки клиента'
    )
})

Mock.onPost('/api/reference/setActiveKlientDirectory').reply((config) => {
    const { id, val } = JSON.parse(config.data || '{}')
    return proxyRequest(
        () => axios.post(buildApiUrl('reference/setKlientDirectoryActive/'), { id, val }),
        'Ошибка изменения статуса клиента'
    )
})

Mock.onPost('/api/reference/setDeletedKlientDirectory').reply((config) => {
    const { id, val } = JSON.parse(config.data || '{}')
    return proxyRequest(
        () => axios.post(buildApiUrl('reference/setKlientDirectoryDeleted/'), { id, val }),
        'Ошибка удаления клиента'
    )
})

Mock.onPost('/api/reference/setUpdateKlientDirectory').reply((config) => {
    const { dataKlientDirectoryUpdate } = JSON.parse(config.data || '{}')
    return proxyRequest(
        () => axios.post(buildApiUrl('reference/setKlientDirectoryUpdate/'), { dataKlientDirectoryUpdate }),
        'Ошибка сохранения клиента'
    )
})

Mock.onPost('/api/reference/setSaveNewKlientDirectory').reply((config) => {
    const { dataKlientDirectoryUpdate } = JSON.parse(config.data || '{}')
    return proxyRequest(
        () => axios.post(buildApiUrl('reference/setSaveNewKlientDirectory/'), { dataKlientDirectoryUpdate }),
        'Ошибка создания клиента'
    )
})
